import { jsx as e, jsxs as f, Fragment as q } from "react/jsx-runtime";
import { useRef as h } from "react";
import A from "reactjs-popup";
import n from "classnames";
import V from "../LoadingButton/index.js";
import $ from "../../icons/Close.js";
import B from "../../hooks/useCloseOnDocumentClick.js";
import F from "./useModalSwipe.js";
import "../../modal-l0sNRNKZ.js";
const X = ({
  open: _,
  onClose: s,
  control: N,
  title: c,
  titleClassName: g,
  contentClassName: C,
  containerClassName: v,
  children: m,
  buttonsClassName: w,
  buttons: t,
  showClose: O = !0,
  showCloseMobile: k = !0,
  viewStyle: d,
  size: r,
  closeOnDocumentClick: R = !0,
  closeOnEscape: M,
  width: S,
  maxWidth: b
}) => {
  const i = h(null), u = h(null);
  F({ handleRef: u, modalRef: i });
  let a = "modal";
  r && (a += ` ${r}`), d && (a += ` ${d}`);
  const x = R ? B() : !1;
  return /* @__PURE__ */ e(
    A,
    {
      className: a,
      trigger: N,
      nested: !0,
      open: _,
      onOpen: () => {
        var o;
        const l = document.querySelectorAll("#popup-root .modal-content");
        (!l.length || l.length === 1) && ((o = window.ReactNativeWebView) == null || o.postMessage("documentIsOpen"), console.log("open"));
      },
      onClose: () => {
        var o;
        s && s(!1), document.querySelectorAll("#popup-root .modal-content").length || ((o = window.ReactNativeWebView) == null || o.postMessage("documentClosed"), console.log("close"));
      },
      closeOnDocumentClick: x,
      closeOnEscape: M,
      contentStyle: { width: S, maxWidth: b },
      lockScroll: !0,
      modal: !0,
      ref: i,
      children: (l) => /* @__PURE__ */ f(q, { children: [
        /* @__PURE__ */ f("div", { className: n("modal__container", v), children: [
          k && /* @__PURE__ */ e("div", { className: "modal__handler", ref: u, children: /* @__PURE__ */ e("span", { className: "modal__handle" }) }),
          c && /* @__PURE__ */ e("div", { className: n("modal__title", g), children: c }),
          m && /* @__PURE__ */ e("div", { className: n("modal__content", "styled-scrollbar", t && "modal__content--with-buttons", C), children: m }),
          t && /* @__PURE__ */ e("div", { className: n("modal__buttons", w), children: t.map(
            ({ children: o, closing: y = !0, onClick: p, ...D }, W) => /* @__PURE__ */ e(
              V,
              {
                fullWidth: !0,
                onClick: (j) => {
                  p && p(j), y && l();
                },
                ...D,
                children: o
              },
              W
            )
          ) })
        ] }),
        O && /* @__PURE__ */ e("div", { className: "modal__close", onClick: () => l(), children: /* @__PURE__ */ e($, { className: "modal__close-icon" }) })
      ] })
    }
  );
};
export {
  X as default
};
